'use strict';

require('../../style/index.less');

require('./index.less');

require('../../tooltip/style');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/slider/style/index.js
// module id = 1566
// module chunks = 0